import { isValidElement, type ReactNode } from 'react'
import classNames from 'classnames'

import ChirpSoapWidgetStyles from './ChirpSoapWidget.module.scss'

export interface ChirpSoapWidgetProps {
  actions?: ReactNode
  children: ReactNode
  classes?: {
    container?: string
    content?: string
    title?: string
  }
  id?: string
  title: string | ReactNode
  /** Renders after the title, still left-aligned before `actions` (e.g. header dropdowns). */
  titleAccessory?: ReactNode
}

const ChirpSoapWidget = ({
  classes: classesProp,
  actions,
  id,
  children,
  title,
  titleAccessory,
}: ChirpSoapWidgetProps) => {
  const containerClassName = classNames(
    ChirpSoapWidgetStyles.container,
    classesProp?.container,
  )
  const titleClassName = classNames(
    ChirpSoapWidgetStyles.title,
    classesProp?.title,
  )
  const titleStartClassName = ChirpSoapWidgetStyles.titleStart
  const contentClassName = classNames(
    ChirpSoapWidgetStyles.content,
    classesProp?.content,
  )

  return (
    <div className={containerClassName} id={id}>
      <div className={titleClassName}>
        <div className={titleStartClassName}>
          {isValidElement(title) ? (
            title
          ) : (
            <h2 className={ChirpSoapWidgetStyles.titleText}>{title}</h2>
          )}
          {titleAccessory}
        </div>
        {actions && (
          <div className={ChirpSoapWidgetStyles.actions}>{actions}</div>
        )}
      </div>
      <div className={contentClassName}>{children}</div>
    </div>
  )
}

export default ChirpSoapWidget
